import React from 'react';
import useStyles from './useStyles';
import { ICalendlyEvent, ICalendlyScoutProps } from '../../../../types';
import { withScoutTheme } from '../../../../../ThemeContext/ThemeContext';
import ReactLoading from 'react-loading';
import { useTheme } from '@mui/styles';
import { useCalendlyEvents } from '../../../../hooks/useCalendlyEvents';
import { CalendlyDetails } from '../../../../CalendlyDetails';

interface IProps {
  calendlyAccount: ICalendlyScoutProps;
  events: ICalendlyEvent[];
  setEvents: (event: ICalendlyEvent[]) => void;
  selectedEvent: ICalendlyEvent;
  setSelectedEvent: (event: ICalendlyEvent | null) => void;
}

function Step2({ calendlyAccount, selectedEvent, setSelectedEvent }: IProps) {
  const classes = useStyles();
  const theme = useTheme();
  const { isLoading, events } = useCalendlyEvents(calendlyAccount);

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <ReactLoading type="spin" color={theme.palette.primary.main} width={45} height={45} />
      </div>
    );
  }

  return (
    <>
      <h4 id="step-2-header">Meeting details</h4>
      <CalendlyDetails
        calendlyAccount={calendlyAccount}
        events={events}
        selectedEvent={selectedEvent}
        setSelectedEvent={setSelectedEvent}
      />
    </>
  );
}

export default withScoutTheme(Step2);
